const FIRST_STRONG_ISOLATE = '\u2068'
const POP_DIRECTIONAL_ISOLATE = '\u2069'

const RIGHT_TO_LEFT_LETTER = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/
const LETTER = /\p{L}/u
const STARTS_WITH_LETTER = /^\s*\p{L}/u
const ENDS_WITH_LETTER_OR_NUMBER = /[\p{L}\p{N}]\s*$/u
const ALREADY_ISOLATED = /^\s*\u2068[\s\S]*\u2069\s*$/

/**
 * Wraps left-to-right text (e.g. an untranslated string or an English date) in a Unicode
 * first-strong isolate when a right-to-left paragraph would otherwise reorder it, so
 * "2 days ago" is not shown as "days ago 2". Only text that starts with a digit or punctuation,
 * or ends with punctuation, reorders; any other text is returned unchanged.
 */
export const isolateLeftToRightText = (text) => {
  if (ALREADY_ISOLATED.test(text)) return text
  if (!LETTER.test(text) || RIGHT_TO_LEFT_LETTER.test(text)) return text
  if (STARTS_WITH_LETTER.test(text) && ENDS_WITH_LETTER_OR_NUMBER.test(text)) return text
  return `${FIRST_STRONG_ISOLATE}${text}${POP_DIRECTIONAL_ISOLATE}`
}

const isDocumentRightToLeft = () => document.documentElement.getAttribute('dir') === 'rtl'

/**
 * Applies isolateLeftToRightText to every template text node, `{{ }}` interpolations included,
 * while the document is right-to-left, by wrapping Vue's `_v` render helper.
 */
export const installLeftToRightTextIsolation = (Vue) => {
  const createTextNode = Vue.prototype._v
  // `_s` would be simpler but also feeds v-html, where isolates around block markup add blank lines.
  // eslint-disable-next-line no-param-reassign
  Vue.prototype._v = function createIsolatedTextNode(text) {
    return createTextNode.call(this, isDocumentRightToLeft() ? isolateLeftToRightText(text) : text)
  }
}
